// extracted by mini-css-extract-plugin
export default {"center":"Container_center__HayFp"};